module.exports = __webpack_public_path__ + "static/media/microphone.6991954b.svg";